<h2 mat-dialog-title>Confirm Login Configuration</h2>

<mat-dialog-content>
  @if (data.isUsingDefault) {
    <div class="default-notice">
      <mat-icon color="warn">info</mat-icon>
      <span>All login methods are disabled. The following <strong>default configuration</strong> will be applied at runtime:</span>
    </div>
  } @else {
    <p>The following login configuration will be saved:</p>
  }

  <div class="config-list">
    <div class="config-row" [class.enabled]="data.config.phoneOtpEnabled">
      <mat-icon>{{ data.config.phoneOtpEnabled ? 'check_circle' : 'cancel' }}</mat-icon>
      <span>Phone OTP</span>
    </div>
    <div class="config-row" [class.enabled]="data.config.emailOtpEnabled">
      <mat-icon>{{ data.config.emailOtpEnabled ? 'check_circle' : 'cancel' }}</mat-icon>
      <span>Email OTP</span>
    </div>
    <div class="config-row" [class.enabled]="data.config.emailPasswordEnabled">
      <mat-icon>{{ data.config.emailPasswordEnabled ? 'check_circle' : 'cancel' }}</mat-icon>
      <span>Email &amp; Password</span>
    </div>
    <div class="config-row" [class.enabled]="data.config.googleEnabled">
      <mat-icon>{{ data.config.googleEnabled ? 'check_circle' : 'cancel' }}</mat-icon>
      <span>Google Sign-In</span>
    </div>
    <div class="config-row" [class.enabled]="data.config.appleEnabled">
      <mat-icon>{{ data.config.appleEnabled ? 'check_circle' : 'cancel' }}</mat-icon>
      <span>Apple Sign-In</span>
    </div>
    <div class="config-row" [class.enabled]="data.config.batSsoEnabled">
      <mat-icon>{{ data.config.batSsoEnabled ? 'check_circle' : 'cancel' }}</mat-icon>
      <span>BAT SSO</span>
    </div>

    <hr class="divider" />

    <div class="config-row meta">
      <mat-icon>login</mat-icon>
      <span>Default login method: <strong>{{ data.config.defaultLoginMethod || 'Phone' }}</strong></span>
    </div>
    <div class="config-row meta">
      <mat-icon>flag</mat-icon>
      <span>Allowed country codes: <strong>{{ allowedCodesLabel }}</strong></span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close(false)">Cancel</button>
  <button mat-flat-button color="primary" (click)="dialogRef.close(true)">Confirm &amp; Save</button>
</mat-dialog-actions>

<style>
  .default-notice {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    background: #fff3e0;
    border-radius: 6px;
    padding: 10px 12px;
    margin-bottom: 16px;
    color: #e65100;
  }
  .config-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 340px;
  }
  .config-row {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #9e9e9e;
  }
  .config-row.enabled {
    color: #2e7d32;
  }
  .config-row.meta {
    color: #424242;
  }
  .config-row mat-icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
  }
  .divider {
    border: none;
    border-top: 1px solid #e0e0e0;
    margin: 4px 0;
  }
</style>
